import React from 'react';
import { Instagram, Youtube, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B0B0B] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="text-white font-bold text-2xl mb-4">
              <span className="text-[#2563EB]">FIT</span>CREATOR
            </div>
            <p className="text-white/60 text-sm">
              Performance-driven fitness content that converts.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-white/60 hover:text-white transition-colors duration-200 text-sm">
                  About
                </a>
              </li>
              <li>
                <a href="#case-studies" className="text-white/60 hover:text-white transition-colors duration-200 text-sm">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="#collaborate" className="text-white/60 hover:text-white transition-colors duration-200 text-sm">
                  Collaborate
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/60 hover:text-white transition-colors duration-200 text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-white font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-white/60 hover:text-[#2563EB] transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="text-white/60 hover:text-[#2563EB] transition-colors duration-200"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
              <a
                href="#"
                className="text-white/60 hover:text-[#2563EB] transition-colors duration-200"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
              <a
                href="#"
                className="text-white/60 hover:text-[#2563EB] transition-colors duration-200"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8">
          <p className="text-white/40 text-sm text-center">
            © {currentYear} FitCreator. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
